import * as Yup from "yup";
import DistrictModel from "../../models/masters/district-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { useEffect, useState } from "react";
import { SelectField } from "../../core/select-field.component";
import { useGetStates } from "../../apiclient/master/useGetStateApi";
import { useGetDistrict } from "../../apiclient/master/useGetDistrictApi";


interface DistrictEditProps {
  data: DistrictModel;
  isViewMode?: boolean;
  onClose?: (status: SubmitStatus, data: any) => any;
}

const DistrictEntry: React.FC<DistrictEditProps> = ({ ...props }) => {
  let { data, onClose,isViewMode } = props;
  const title = data?.districtId > 0 ? "Edit District" : "Add District";  

  let initialValue: DistrictModel = {
    districtId: data?.districtId ? data.districtId : 0,
    code: data?.code,            
    name: data?.name,
    capital: data?.capital,
    stateId: data?.stateId,
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
    .required("Required")
    .test("check-duplicate-name", "District name already exists", (value) => {
      // Ensure the value is compared in a case-insensitive manner
      return (
        value &&
        !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
        (data?.name && value === data.name) // Allow current name during update
      );
    }), 

    code: Yup.string()
      .required("Required")
      .test("check-duplicate-code", "Code already exists", (value) => {
        return (
          value &&
          !existingCode.includes(value) ||
          (data?.code && value === data.code) // Allow current code during update
        );
      }),

    capital: Yup.string().required("Required"),
  });

  const [existingCode, setExistingCode] = useState<string[]>([]);
  const [existingName, setExistingName] = useState<string[]>([]);

  const { data: fetchedDistrict } = useGetDistrict();
  const [stateData, setStateData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedState } = useGetStates();

  useEffect(() => {
    if (fetchedDistrict) {
      setExistingCode(fetchedDistrict.map((cat: any) => cat.code));
      setExistingName(fetchedDistrict.map((cat: any) => cat.name));
    }

    if (fetchedState) {
      const mappedState = fetchedState.map((state: any) => ({
        value: state.stateId,
        label: state.name,
      }));
      setStateData(mappedState);
    }
  }, [fetchedState, fetchedDistrict]);

  return (
    <>
      <FormikModelDialog
        width="50%"
        title={title}
        initialData={initialValue}
        validationSchema={validationSchema}
        show={!!data}
        onClose={onClose}
        endpoint={API_END_POINT.MASTER}
        postRoute="District/SaveDistrict"
        showAddAnother={true}
        isViewOnly ={isViewMode}
        isUpDateEntityDetails={data?.districtId > 0 ? true : false}
      >
        <div>
          <div className="row">
            <div className="col-3">
              <InputField maxLength={10} label="Code *" name="code" />
            </div>
            <div className="col-6">
              <InputField maxLength={100} label="District *" name="name" />
            </div>
            <div className="col-6">
              <InputField maxLength={150} label="Capital *" name="capital" />
            </div>
            <div className="col-6">
              <SelectField
                label="State"
                name="stateId"
                options={stateData}
                unSelectValue={0}
              />       
            </div>
          </div>
        </div>
      </FormikModelDialog>
    </>
  );
};

export default DistrictEntry;
